module.exports = __webpack_public_path__ + "static/img/downlod.1430155d.svg";